import { createAction } from "redux-actions";

//Actions para guardar reducer de los catálogos de cotizacion

//CATALOGOS TRAVEL BTA EMPRESSA -----------------------
export const setTarifacion = createAction("SET_TARIFACION_BTA_EMPRESAS");
export const setIdCotizacionActual = createAction("SET_ID_COTIZACION_ACTUAL");
export const setIngresoInfCliente = createAction("SET_INGRESO_INF_CLIENTE");
export const setLoadingCotizador = createAction("SET_LOADING_COTIZADOR");

export const FetchIngresoInfCliente = (param) => async (dispatch) => {
  dispatch(setIngresoInfCliente(param));
};

export const FetchLoadingCotizador = (param) => async (dispatch) => {
  dispatch(setLoadingCotizador(param));
};

export const FetchIdCotizacionActual = (param) => async (dispatch) => {
  dispatch(setIdCotizacionActual(param));
};

export const FetchTarifacion = (param) => async (dispatch) => {
  dispatch(setTarifacion(param));
};
// FIN CATALOGOS TRAVEL BTA EMPRESSA -----------------------
